import { Component, Input, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ThemeModeService, ThemeModeType } from './theme-mode.service';
import { CommonModule } from '@angular/common';
import { KeeniconComponent } from '../keenicon/keenicon.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
	selector: 'app-theme-mode-switcher',
	templateUrl: './theme-mode-switcher.component.html',
	imports: [CommonModule, KeeniconComponent, TranslateModule],
	standalone: true,
})
export class ThemeModeSwitcherComponent implements OnInit {
	@Input() toggleBtnClass = '';
	@Input() toggleBtnIconClass = 'svg-icon-2';
	@Input() menuPlacement = 'bottom-end';
	@Input() menuTrigger = "{default: 'click', lg: 'hover'}";
	mode$: Observable<ThemeModeType> = new Observable<ThemeModeType>();
	menuMode$: Observable<ThemeModeType> = new Observable<ThemeModeType>();

	private modeService = inject(ThemeModeService);

	ngOnInit(): void {
		this.mode$ = this.modeService.mode.asObservable();
		this.menuMode$ = this.modeService.menuMode.asObservable();
	}

	switchMode(_mode: ThemeModeType): void {
		this.modeService.switchMode(_mode);
	}
}
